import { createOpenFetchClient, createUseOpenFetchClient, createUseLazyOpenFetchClient } from '#imports'
import type { paths as ApiPaths } from '#build/types/nuxt-open-fetch/api'

export type OpenFetchClientName = 'api'

export const $apiFetch = createOpenFetchClient<ApiPaths>('api')
export const useApiFetch = createUseOpenFetchClient<ApiPaths>('api')
export const useLazyApiFetch = createUseLazyOpenFetchClient<ApiPaths>('api')
